import { ItemStatus } from "#/types/items";
import { useClient } from "#/hook/useClient";

/**
 * Hook that returns the list of allowed statuses for the current client.
 * If no statuses are configured (undefined or empty array), returns all statuses by default.
 */
export const useAllowedStatuses = (): ItemStatus[] => {
  const { client } = useClient();

  // If no allowedStatuses configured or empty, return all statuses
  if (!client?.allowedStatuses || client.allowedStatuses.length === 0) {
    return Object.values(ItemStatus);
  }

  // Return only the allowed statuses for this client
  return client.allowedStatuses;
};
